
import { CompanyDossierService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			version: 0,
			submitting: false
		};
	},
	props: {
		dossierId: {
			type: Number,
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (this.submitting) return;
			if (this.version === null || this.version < 0){
				this.$wf.notify("Ongeldig migratie ID", "danger", 3000, "exclamation-triangle");
				return;
			}
			let confirm = await this.$wf.confirm(`Weet je zeker dat je migratie ${this.version} opnieuw wilt uitvoeren?`, "Ja", "Nee", "Waarschuwing", "warning");
			if (!confirm) return;
			try{
				this.submitting = true;
				await CompanyDossierService.runSpecificMigration(this.dossierId, this.version);
				this.$wf.notify(`Migratie ${this.version} wordt uitgevoerd`, "info", 3000, "info");
				this.close();
			}catch(err){

			}finally{
				this.submitting = false;
			}
		}
	}
});
